module.exports = __webpack_public_path__ + "img/EnBanner.367c01c8.jpg";